import { Button } from "../Button";

export interface ErrorStateProps {
  title?: string;
  message?: string;
  /** Stable machine code (from ApiError.code) — shown discreetly for support/audit. */
  code?: string;
  onRetry?: () => void;
}

/** ErrorState — one of the 5 mandatory per-screen states (erreur). Glyph + text, not color-only. */
export function ErrorState({
  title = "Une erreur est survenue",
  message = "Impossible de charger les données.",
  code,
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="nv-state nv-state--error" role="alert">
      <div className="nv-state__glyph" aria-hidden>
        ◆
      </div>
      <div className="nv-state__title">{title}</div>
      <p className="nv-state__desc">{message}</p>
      {code && (
        <p className="nv-mono" style={{ fontSize: "var(--nv-fs-caption)", color: "var(--nv-steel)" }}>
          {code}
        </p>
      )}
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          Réessayer
        </Button>
      )}
    </div>
  );
}
